module.exports = __webpack_public_path__ + "img/hzserive3.b1fd8248.jpg";